import React, { useState, useEffect } from "react";
import { Message } from "semantic-ui-react";
import { api, useApi } from "../api/api";
import { ArchiveStatusProps } from "../api/io";

interface InfoAlertProps {
    message: string;
    onClose: (url: string) => void;
    archiveKey: string;
}

const InfoAlert: React.FC<InfoAlertProps> = ({ message, onClose, archiveKey }) => {
    const bucketApi = useApi(api.bucket);
    const [archiveStatus, setArchiveStatus] = useState<ArchiveStatusProps>();

    const getArchiveStatus = () => {
        bucketApi.getArchiveStatus(archiveKey).then(archiveStatusHandler);
    };

    const archiveStatusHandler = (response: ArchiveStatusProps) => {
        if (response.status === "done") {
            onClose(response.url);
        }
        setArchiveStatus(response);
    };

    useEffect(() => {
        const interval = setInterval(getArchiveStatus, 3000);

        return () => {
            clearInterval(interval);
        };
    }, []);

    return (
        <div style={{ position: "fixed", bottom: "20px", right: "20px", zIndex: 9999 }}>
            <Message compact info floating>
                <div>
                    {message}
                    {archiveStatus ? `(${archiveStatus.files_processed}/${archiveStatus.files_count})` : "(0/...)"}
                </div>
            </Message>
        </div>
    );
};

export default InfoAlert;
